import { apiFetch } from '@/shared/api/client'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'
import { loadTodayTripPreferApi } from '@/features/delman/api/delmanTripApi'
import { delmanTerms } from '@/features/delman/delmanTerms'
import { blocksDelmanCheckout } from '@/features/delman/storage/tripStorage'
import { runKitchenSync } from '@/shared/sync/kitchenSync'
import { getDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import type { AttendanceAction } from '@/features/kitchen/api/submitAttendance'

export type SubmitDelmanAttendanceRequest = {
  deviceId: string
  delmanId: string
  pin: string
  action: AttendanceAction
  photoUrl: string
}

export type SubmitDelmanAttendanceResponse = {
  recorded_at: string
  on_time?: boolean
}

const MOCK_DELMAN_PIN = '123456'

export function validateDelmanPin(_delmanId: string, pin: string): boolean {
  return pin === MOCK_DELMAN_PIN
}

async function mockSubmit(req: SubmitDelmanAttendanceRequest): Promise<SubmitDelmanAttendanceResponse> {
  if (!validateDelmanPin(req.delmanId, req.pin)) {
    throw new Error('PIN tidak cocok. Gunakan PIN pribadi delman.')
  }
  if (!req.photoUrl) {
    throw new Error('Foto selfie wajib diambil.')
  }
  if (req.action === 'check_out') {
    const device = getDelmanDevice()
    if (device) {
      const trip = await loadTodayTripPreferApi({
        delmanId: device.delmanId,
        delmanName: device.delmanName,
        kitchenName: device.kitchenName,
      })
      if (blocksDelmanCheckout(trip)) {
        throw new Error(delmanTerms.attendance.tripNotCompleted)
      }
    }
  }
  return {
    recorded_at: new Date().toISOString(),
    on_time: req.action === 'check_in',
  }
}

async function submitDirect(req: SubmitDelmanAttendanceRequest): Promise<SubmitDelmanAttendanceResponse> {
  if (shouldUseDelmanMock()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockSubmit(req)
  }

  const path = req.action === 'check_in' ? '/attendance/check-in' : '/attendance/check-out'

  return apiFetch<SubmitDelmanAttendanceResponse>(path, {
    method: 'POST',
    body: JSON.stringify({
      device_id: req.deviceId,
      user_id: req.delmanId,
      pin: req.pin,
      photo_url: req.photoUrl,
    }),
  })
}

export async function submitDelmanAttendanceDirect(
  req: SubmitDelmanAttendanceRequest,
): Promise<SubmitDelmanAttendanceResponse> {
  return submitDirect(req)
}

export async function submitDelmanAttendance(
  req: SubmitDelmanAttendanceRequest,
): Promise<SubmitDelmanAttendanceResponse> {
  const actionLabel = req.action === 'check_out' ? 'Keluar' : 'Masuk'
  return runKitchenSync(
    {
      type: 'delman_attendance',
      label: `Absensi delman ${actionLabel}`,
      payload: req,
    },
    () => submitDirect(req),
    () => ({
      recorded_at: new Date().toISOString(),
      on_time: req.action === 'check_in',
    }),
  )
}
